import Hero     from '../components/home/hero';
import Recent   from '../components/home/recent';
import About    from '../components/home/about';
import Reviews  from '../components/home/reviews';

export default function Home() {
    return(
        <>
            <Hero />
            <Recent />
            <About />
            <Reviews />
        </>
    )
}